import { isEmpty } from "lodash";
import { LoadingDots } from "PFComponents/loading_dots";
import { useExportFilters } from "PFCore/hooks/queries/analytics/booking_export/use_export_filters";
import { Filter } from "PFTypes";
import React, { JSX, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { FiltersGroup } from "./filters_group";
import css from "./filters_tab.module.scss";
import { mapValuesInFilterGroup } from "./helpers";
import { STANDARD_FILTERS_NAME, useFilterGroups } from "./use_filter_groups";
import { usePeriodSelector } from "./use_period_selector";

export const FiltersTab = (): JSX.Element => {
  const { t } = useTranslation("insights", { keyPrefix: "exportWizard.filters.groups" });
  const { data, isLoading } = useExportFilters();
  const { ungroupedFilters, filterGroups } = useFilterGroups({
    entries: data?.entries
  });
  const { minDate, options } = usePeriodSelector();

  const nonEmptyFilterGroups = useMemo(
    () =>
      (filterGroups &&
        Object.entries(filterGroups).filter(([, filterGroup]) =>
          Object.values(filterGroup).some((filterFamily) => !isEmpty(filterFamily))
        )) ||
      [],
    [filterGroups]
  );

  const ungroupedFiltersWithProps = useMemo(
    () =>
      mapValuesInFilterGroup<Filter, Filter & Record<string, any>>(ungroupedFilters, () => (filter) => ({
        ...filter,
        ...(filter.name === "period" ? { isClearAvailable: false, minDate, options } : {})
      })),
    [ungroupedFilters, minDate, options]
  );

  return (
    <>
      {isLoading && <LoadingDots circlesEnabled className={css.loading} />}
      {ungroupedFiltersWithProps && (
        <FiltersGroup
          isExpandable={false}
          name={STANDARD_FILTERS_NAME}
          loading={isLoading}
          filters={ungroupedFiltersWithProps}
        />
      )}
      <div className={css.filtersGroupContainer}>
        {nonEmptyFilterGroups.map(([groupName, filters]) => (
          <FiltersGroup
            key={groupName}
            name={groupName}
            label={t(groupName as unknown as TemplateStringsArray)}
            loading={isLoading}
            filters={filters}
          />
        ))}
      </div>
    </>
  );
};
